/** @jsxImportSource @emotion/react */
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { accessAPI, storeInLS, urlLogin } from "../../shared";
import { Skeleton } from "primereact/skeleton";

export default function Login() {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (state?.oauthtoken) {
      accessAPI(
        "POST",
        "oauth/onetimesignon",
        { oauthtoken: state?.oauthtoken },
        (response) => {
          storeInLS(process.env.REACT_APP_LS_LOGIN_TOKEN, response.token);
          // Usar window.location para forzar recarga completa y asegurar que el token esté disponible
          window.location.href = "/";
        },
        (response) => {
          window.location.href = urlLogin();
        },
      );
    } else {
      window.location.href = urlLogin();
    }
  }, [state, navigate]);

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: "1rem",
      }}
    >
      <Skeleton shape="circle" size="4rem" />
      <Skeleton width="12rem" height="1.5rem" />
      <Skeleton width="8rem" height="1rem" />
    </div>
  );
}
